import Event from '../../event';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Media from './Media';

const Events = [
    'loadstart',
    'suspend',
    'abort',
    'error',
    'emptied',
    'stalled',
    'loadedmetadata',
    'loadeddata',
    'canplay',
    'canplaythrough',
    'playing',
    'waiting',
    'seeking',
    'seeked',
    'ended',
    'durationchange',
    'timeupdate',
    'progress',
    'play',
    'pause',
    'ratechange',
    'volumechange',
];

class AdCore extends Component {
    static propTypes = {
        frontAd: PropTypes.object,
        playermsg: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.opt = props;
        this.state = {
            isRender: true,
        };
        this.event = new Event();
    }

    componentDidMount() {
        // 获取广告音量
        const volList = this.props.frontAd.vol;
        const refs = this.refs;

        this.el = refs;

        // 设置音量
        for (const key in refs) {
            const item = refs[key];

            item.setVolume(volList[key]);
        }
    }

    // AD播放后调高音量
    adStartHVolume() {
        const volList = this.props.frontAd.vol;
        const refs = this.refs;

        for (const index in refs) {
            const item = refs[index];

            item.setVolume(volList[index]);
        }
    }

    cancelVideoMuted() {
        const volList = this.props.frontAd.vol;
        const refs = this.refs;

        for (const index in refs) {
            const item = refs[index];

            item.setMuted(false);
            item.setVolume(volList[index]);
        }
    }

    // 播放
    adPlay(index) {
        if (index > 0) {
            this.el[index - 1].hide();
        }
        this.el[index].show();

        const playPromise = this.el[index].play();

        if (playPromise && playPromise.catch) {
            playPromise.catch((err) => {
                console.log(err);
                this.el[index].setVolume(0);
                this.el[index].setMuted(true);
                this.event.trigger('mutePlay');
                this.el[index].play();
            });
        }

        this.dom = this.el[index].getDom();
        this.clickUrl = this.opt.frontAd.clickUrl[index];
    }

    // 静音
    adVolume() {
        const refs = this.refs;

        for (const index in refs) {
            const item = refs[index];

            if (item.getVolume() === 0) {
                item.setVolume(1);
            } else {
                item.setVolume(0);
            }
        }
    }

    on(eventName, callback, ele) {
        if (Events.indexOf(eventName) >= 0) {
            ele.on(eventName, callback);
        } else {
            this.event.on(eventName, callback);
        }
    }

    off(eventName, callback, ele) {
        if (Events.indexOf(eventName) >= 0) {
            ele.off(eventName, callback);
        } else {
            this.event.off(eventName, callback);
        }
    }

    destory() {
        this.setState({
            isRender: false,
        });
    }

    getChildren() {
        const { frontAd, playermsg } = this.props;
        const { adUrl, materialType, materialWidth, materialHeight, oneadTime } = frontAd;

        return adUrl.map((src, i) => {
            return (
                <Media
                    key={i}
                    index={i}
                    url={src}
                    type={materialType[i]}
                    width={materialWidth[i]}
                    height={materialHeight[i]}
                    duration={oneadTime[i]}
                    ref={i}
                    playermsg={playermsg}
                />
            );
        });
    }

    render() {
        const { isRender } = this.state;
        const children = this.getChildren();

        return isRender ? children : null;
    }
}

export default AdCore;
